import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Alert, Button, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import Logo from "../assets/images/logo.png";
import { DesktopContainer } from "../layouts";
import { api } from "../utils";

const getResetToken = (url) => {
  let youUrl = url;
  let token = youUrl.split('/')[2]
  return token
}

export default function ResetPassword(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const Token = getResetToken(location.pathname)
  const [authData, setAuthData] = useState({
    password: "",
    passwordAgain: "",
    resetToken:
      Token
        ? Token
        : null,
  });
  const [message, setMessage] = useState(null);

  function onChange(fieldName, fieldValue) {
    let newData = Object.assign({}, authData);
    newData[fieldName] = fieldValue;
    setAuthData(newData);
  }

  function onSubmit() {
    const warnings = validate();
    if (warnings.length) {
      setMessage({
        text: warnings.join(" "),
        flavor: "alert-danger",
      });
      return;
    } else {
      setMessage(null);
    }
    api
      .post("Public/SetPassword", {
        token: authData.resetToken,
        password: authData.password,
      })
      .then((response) => {
        if (api.isRateLimited(response)) return;   // already toasted by the api interceptor
        if (response && response.data && response.data.success) {
          setMessage({
            flavor: "alert-success",
            text: "You have successfully reset your password. We're now redirecting you to the home screen.",
          });
          setTimeout(() => {
            navigate("/login")
          }, 5000);
        } else {
          setMessage({ flavor: "alert-danger", text: response?.data?.message });
        }
      })
      .catch(api.catchHandler);
  }

  function validate() {
    let warnings = [];
    if (!authData.password || authData.password.length < 8) {
      warnings.push(
        "Password is required and must be at least 8 characters long."
      );
    }
    if (authData.password !== authData.passwordAgain) {
      warnings.push("The password and password confirmation do not match.");
    }
    return warnings;
  }

  return (
    <DesktopContainer fluid className="pt-5">
      <Row className="pt-5 justify-content-center position-static">
        <Col xs={6}>
          <Row className="pt-5 justify-content-center">
            <img id="Logo" src={Logo} alt="logo" style={{ width: "150px" }} />
          </Row>
          <Row className="mt-3">
            <Col xs={12}>
              <Form>
                <FormGroup>
                  <Label> New Password</Label>
                  <Input
                    type="password"
                    value={authData.password}
                    onChange={(e) => onChange("password", e.target.value)}
                    placeholder="Password"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>Confirm Password</Label>
                  <Input
                    type="password"
                    value={authData.passwordAgain}
                    onChange={(e) =>
                      onChange("passwordAgain", e.target.value)
                    }
                    placeholder="Re-Type Password"
                  />
                </FormGroup>
                <FormGroup>
                  <Label>{""}</Label>
                  <Button
                    className="projectPrimary float-end"
                    onClick={onSubmit}
                    children="Confirm Password Reset"
                  />
                </FormGroup>
                <FormGroup>
                  <Link
                    to="/login"
                    className="float-end"
                    children="Wait, I remember my account info - take me to log in!"
                  />
                </FormGroup>
              </Form >
            </Col>
          </Row>
          {
            message ? (
              <Row className="mb-2" >
                <Col>
                  <Alert className={message.flavor}>{message.text}</Alert>
                </Col>
              </Row>
            ) : null
          }
        </Col >
      </Row >
    </DesktopContainer >
  );
}
